/**
 * Shared color palette for ClauseClear dark theme
 * Colors extracted from the official ClauseClear logo
 */

export const colors = {
  // Backgrounds - from logo background #2E334A
  background: '#2E334A',      // Deep muted navy (logo background)
  backgroundLight: '#3A3F54', // Slightly lighter for cards
  backgroundDark: '#252938',  // Darker sections
  
  // Text - from logo text #FFFFFF
  text: '#FFFFFF',            // Pure white - primary text
  textMuted: '#B8BCC8',       // Muted grey - secondary text
  textDim: '#8A8F9E',         // Even more muted - tertiary text
  
  // Accent - from logo gold rings #D4AF37
  accent: '#D4AF37',          // Rich metallic gold (logo rings)
  accentHover: '#C9A432',     // Slightly darker gold for hover
  
  // Borders - derived from logo colors
  border: '#3E4459',          // Subtle border
  borderLight: '#4E536A',     // Lighter border for focus/hover
  
  // Semantic
  info: '#3A4A6B',            // Info background
  infoBorder: '#4A5A7B',      // Info border
  error: '#5A3A3A',           // Error background
  errorText: '#FFB8B8',       // Error text
  
  // Highlight - from logo outer edge #EAEFF1
  highlight: '#EAEFF1',       // Pale blue-grey highlight
};

export default colors;
